import apiInstance from "@api/apiInstance";
import { StudyWordsFilters, WordStudy } from "interfaces/Vocabulary/VocabularyInterfaces";
import {
	agregarDiaPropio,
	enEspejo,
	espejoInowu,
	migrarDiasPropio,
	rachaPropia,
	registrarRondaPropia,
	rondasEnPeriodoPropio,
	usarAvancePropio,
} from "@api/AvancePropio";
import {
	palabrasPorIdiomaPropio,
	progresoDePalabraPropio,
	progresoDelRangoPropio,
	progresoPorIdiomaPropio,
} from "@api/VocabularioPropio";

// Con el avance propio encendido (ver api/AvancePropio.ts) todo esto se contesta con nuestro Firestore
// y la copia del vocabulario, sin preguntarle a Inowu.

export const fetchVocabularyProgress = async (startSeminary: number, endSeminary: number) => {
	if (usarAvancePropio()) return progresoDelRangoPropio(startSeminary, endSeminary);
	return apiInstance
		.get(`vocabulary/progress?startSeminary=${startSeminary}&endSeminary=${endSeminary}`)
		.then((res) => {
			return res.data;
		});
};

export const fetchProgressLanguageBySeminary = async (startSeminary: number, endSeminary) => {
	if (usarAvancePropio()) return progresoPorIdiomaPropio(startSeminary, endSeminary);
	return apiInstance
		.get(`vocabulary/progress-languages?startSeminary=${startSeminary}&endSeminary=${endSeminary}`)
		.then((res) => {
			return res.data;
		});
};

export const fetchWordsBySeminaryAndLanguage = async (
	language: string,
	startSeminary: number,
	endSeminary: number
) => {
	if (usarAvancePropio()) return palabrasPorIdiomaPropio(language, startSeminary, endSeminary);
	return apiInstance
		.get(
			`vocabulary/language-words?language=${language}&startSeminary=${startSeminary}&endSeminary=${endSeminary}`
		)
		.then((res) => {
			return res.data;
		});
};

export const fetchWordProgress = async (wordDataId: number) => {
	if (usarAvancePropio()) return progresoDePalabraPropio(wordDataId);
	return apiInstance.get(`vocabulary/word-progress/${wordDataId}`).then((res) => {
		return res.data;
	});
};

export const fetchVocabularyStreakAndDays = async (userId: string, timezone: string) => {
	if (usarAvancePropio()) return rachaPropia(userId, timezone);
	return apiInstance
		.get(`user/${userId}/streak`, { params: { timezone: timezone } })
		.then((res) => {
			return res.data;
		});
};

export const migrateVocabularyStudiedDays = async (
	userId: string,
	dates: string[],
	timezone: string
) => {
	if (usarAvancePropio()) return migrarDiasPropio(userId, dates, timezone);
	return apiInstance
		.post(`user/${userId}/migrate-firestore`, { timezone: timezone, firestoreDates: dates })
		.then((res) => {
			return res.data;
		});
};

export const addVocabularyStudiedDay = async (userId: string, date: string, timezone: string) => {
	if (usarAvancePropio()) {
		if (espejoInowu(userId)) enEspejo(() => apiInstance.post(`user/${userId}/study-day`, { studyDate: date, timezone }));
		return agregarDiaPropio(userId, date, timezone);
	}
	return apiInstance.post(`user/${userId}/study-day`, { studyDate: date, timezone }).then((res) => {
		return res.data;
	});
};

export const registerWordsStudied = async (
	userId: string,
	seminaryId: number,
	studied_words: WordStudy[]
) => {
	if (usarAvancePropio()) {
		if (espejoInowu(userId)) {
			enEspejo(() => apiInstance.post(`study-history`, { user_id: userId, seminary_id: seminaryId, studied_words }));
		}
		return registrarRondaPropia(userId, seminaryId, studied_words as any);
	}

	console.log("userId",userId,"seminaryId",seminaryId, "studied_words", studied_words);
	const res = await apiInstance.post(`study-history`, {
		user_id: userId,
		seminary_id:seminaryId,
		studied_words,
	});
	return res.data;
};

export const getWordStudiedPerPeriod = async (params: StudyWordsFilters) => {
	if (usarAvancePropio()) return rondasEnPeriodoPropio(params as any);
	const res = await apiInstance.get(`study-history`, { params: params });
	return res.data;
};
